import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { EntityExtensionClass, IEntity } from './entities/entity';

function getEntityQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getEntityInput(organizationNumber: string): IDataServiceRequest {
    const query = getEntityQuery();
    return query.createDataServiceRequestForOperation(
        'GetEntity',
        false,
        EntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'IEntity' },
        {
            organizationNumber: organizationNumber
        }
    );
}

export function getEntityAsync(context: IContext, organizationNumber: string): AsyncResult<IEntity> {
    const request = getEntityInput(organizationNumber);
    return callActionOrExecute<IEntity>(request, context.callerContext);
}
